export default __webpack_public_path__ + "static/media/commonroad-io.df6593d2.md";